module.exports = __webpack_public_path__ + "static/media/imgGalleryM3.a3b9299a.svg";